export const SET_LOADER = 'SET_LOADER';

export const setLoader = loader => ({
    type: SET_LOADER,
    loader,
});
